export const CHECKOUT_URL =
  'https://atleta-corporativo.impultienda.ar/o/programa-1-atleta-corporativo'

export const painPoints = [
  {
    title: 'Las 15:00 donde el cerebro se apaga',
    description:
      'El crash de la tarde llega puntual y ni el quinto café lo detiene. Solo taquicardia y foco que dura 40 minutos.',
    icon: 'brain',
  },
  {
    title: 'Llegar a casa sin nada para dar',
    description:
      'Cerrás la laptop y solo queda el sillón. Estás presente en cuerpo, ausente en todo lo demás.',
    icon: 'battery',
  },
  {
    title: 'Desconectar nunca sucede',
    description:
      'Rumiación nocturna, domingo con ansiedad anticipatoria y un fin de semana que termina sin recuperarte.',
    icon: 'unplug',
  },
]

export const painList = [
  'Las 15:00 donde el cerebro se apaga y ni el café ayuda',
  'Llegar a casa y no tener energía para nada que no sea el sillón',
  'El domingo con ansiedad anticipatoria pensando en el lunes',
  'Cinco cafés por día que ya no te despiertan, solo te dan taquicardia',
  'Dolores de cuello y espalda que se volvieron "normales"',
  'Foco que dura 40 minutos y después saltás de tab en tab sin producir',
  'Reuniones que drenan más energía de la que tenés disponible',
  'Fin de semana que termina sin haberte recuperado realmente',
]

export const tomos = [
  {
    number: '01',
    title: 'El Despertar del Atleta Corporativo',
    window: '9:00 a 12:00',
    description:
      'Cortisol, luz solar, hidratación celular y el bloque de foco más poderoso del día.',
  },
  {
    number: '02',
    title: 'El Hackeo del Mediodía',
    window: '12:00 a 14:00',
    description:
      'Comandos de delivery inteligente, digestión sin coma alimentario y recarga energética estratégica.',
  },
  {
    number: '03',
    title: 'La Hora Más Peligrosa',
    window: '14:00 a 17:00',
    description:
      'Cómo sobrevivir y rendir en las horas donde todos bajan el rendimiento.',
  },
  {
    number: '04',
    title: 'Tu Entorno te está Programando',
    window: 'Todo el día',
    description:
      'Temperatura, luz, ruido, biofilia y entorno digital sin distracciones.',
  },
  {
    number: '05',
    title: 'El Capítulo más Ignorado del Rendimiento',
    window: '16:00 a 17:00',
    description:
      'Shutdown Ritual, desconexión sin culpa y transición al modo personal.',
  },
  {
    number: '06',
    title: 'El Último Hack del Sistema',
    window: '17:00 a 9:00',
    description:
      'Arquitectura del sueño, protocolo pre-sueño y despertar estratégico.',
  },
]

export const tomoIncludes = [
  'Protocolo listo para implementar desde el día 1',
  'Base científica con referencias actualizadas',
  'Adaptado al ritmo laboral argentino (9 a 17)',
  'Checklists, worksheets y timelines accionables',
  'Casos reales de oficina y home office argentinos',
  'Versión imprimible y versión digital optimizada',
  'Prompts visuales para cada sección',
  'Sin gimnasio, sin dietas extremas, sin apps complicadas',
]

export const bonos = [
  {
    number: '01',
    title: 'Kit de Implementación Express 7 Días',
    description:
      'Instalá los primeros hábitos del sistema en una semana. Un hábito por día, sin fricción.',
    price: '$12.000',
  },
  {
    number: '02',
    title: 'Comandos de Delivery Inteligente',
    description:
      'PedidosYa, Rappi y Uber Eats: qué pedir en cada local para no destruir la energía de la tarde.',
    price: '$9.000',
  },
  {
    number: '03',
    title: 'Tarjetas de Reseteo en Escritorio',
    description:
      '24 tarjetas imprimibles para resetear el sistema nervioso en 60 segundos desde tu silla.',
    price: '$8.000',
  },
  {
    number: '04',
    title: 'Planner de Energía 9 a 17',
    description:
      'Planificá por energía, no por urgencias. El planner semanal del Atleta Corporativo.',
    price: '$10.000',
  },
  {
    number: '05',
    title: 'Scripts de Límites Laborales y Desconexión',
    description:
      '22 scripts listos para decir "no ahora" sin conflictos. Mail, WhatsApp, Slack y presencial.',
    price: '$9.000',
  },
  {
    number: '06',
    title: 'Checklist de Setup Express Home & Oficina',
    description:
      'Transformá tu escritorio en un entorno de alto rendimiento en una tarde. Sin comprar nada caro.',
    price: '$8.000',
  },
]

export const testimonials = [
  {
    initials: 'MG',
    name: 'Martín G.',
    location: 'Buenos Aires',
    role: 'Gerente de Operaciones',
    quote:
      'Llegaba a casa destruido. Ahora a las 17:00 todavía tengo energía para salir a caminar con mis hijos. El Tomo 3 me cambió la tarde.',
  },
  {
    initials: 'LP',
    name: 'Laura P.',
    location: 'Rosario',
    role: 'Directora Comercial',
    quote:
      'El Cocktail de Enfoque del Tomo 1 reemplazó mi tercer café. Tres semanas después, la diferencia en el foco de la mañana es brutal.',
  },
  {
    initials: 'RM',
    name: 'Roberto M.',
    location: 'Córdoba',
    role: 'Contador Senior',
    quote:
      'El Protocolo de Cierre del Tomo 5 fue lo que necesitaba. Cierro la laptop a las 17:00 sin culpa y duermo como no dormía hace 10 años.',
  },
]

export const eliteRows = [
  {
    situation: 'After office o asado corporativo que no podés evitar',
    without: 'Llegás al día siguiente destruido',
    with: 'Protocolo de Alcohol Estratégico. Salida elegante. Mañana al 100%.',
  },
  {
    situation: 'Semana de crisis donde dormir 7 horas es imposible',
    without: 'Improvisás con más café y voluntad',
    with: 'Sprint de 72 Horas. Nap táctico. Cafeína estratégica.',
  },
  {
    situation: 'Negociación o presentación crítica de alto impacto',
    without: 'Llegás con el sistema nervioso activado',
    with: 'Power Posing + 7 Herramientas de Dominancia Biológica.',
  },
  {
    situation: 'Enfermás apenas te relajás el sábado',
    without: 'El cuerpo te pasa factura sin aviso',
    with: 'Reset Post-Crisis. Protocolo de descenso de cortisol en 48 horas.',
  },
  {
    situation: 'Necesitás foco extremo para un proyecto clave',
    without: 'Más café que solo genera ansiedad',
    with: 'Stack Táctico de Nootrópicos legales en Argentina.',
  },
  {
    situation: 'Explotó todo en la oficina a las 10 AM',
    without: 'Reaccionás desde el estrés',
    with: 'Switch de Emergencia. Box Breathing Táctico. Triage de Crisis.',
  },
]

export const eliteIncludes = [
  'Switch de Emergencia — La neurociencia del atleta bajo fuego',
  'Supervivencia Social y Networking — After office y asados sin costo biológico',
  'El Sprint de 72 Horas — Rendir cuando el sueño es limitado',
  'La Gran Negociación — Dominancia biológica en la mesa de decisiones',
  'Nootrópicos y Suplementación Táctica — El nivel avanzado (legales en Argentina)',
  'El Reset Post-Crisis — Blindando el sistema inmune post-sprint',
]

export const plans = [
  {
    id: 'standard',
    name: 'Programa Atleta Corporativo',
    subtitle: '6 Tomos + 6 Bonos',
    idealFor:
      'El profesional que quiere optimizar su jornada completa de 9 a 17',
    originalPrice: '$69.000',
    price: '$24.990',
    features: [
      'Los 6 Tomos completos (420+ páginas)',
      'Los 6 Bonos estratégicos — valor $56.000',
      'Jornada completa optimizada: 9 a 17',
      'Versión imprimible y digital',
      'Acceso inmediato en 5 minutos',
    ],
    cta: 'Quiero mi Programa',
    featured: false,
  },
  {
    id: 'elite',
    name: 'Atleta Corporativo Élite',
    subtitle: '6 Tomos + 6 Bonos + Protocolo de Intervención Crítica',
    idealFor:
      'El profesional que también necesita rendir bajo presión extrema, negociaciones críticas y situaciones de alta exigencia',
    originalPrice: '$99.000',
    price: '$34.990',
    features: [
      'Todo lo del Programa Atleta Corporativo',
      'Protocolo de Intervención Crítica completo',
      'Switch de Emergencia y Triage de Crisis',
      'Sprint de 72 Horas y Reset Post-Crisis',
      'Stack Táctico de Nootrópicos (Argentina)',
      'Dominancia biológica para negociaciones',
    ],
    cta: 'Quiero mi Programa Élite',
    featured: true,
  },
]

export const faqs = [
  {
    question: '¿Necesito ir al gimnasio o hacer dieta?',
    answer:
      'No. El sistema está diseñado para aplicarse dentro de tu jornada laboral, en tu escritorio, con lo que ya tenés. Sin rutinas de ejercicio obligatorias, sin dietas restrictivas. Si ya hacés ejercicio, el sistema potencia eso. Si no hacés, el sistema funciona igual.',
  },
  {
    question: '¿Cuánto tiempo requiere por día?',
    answer:
      'Los protocolos de reseteo duran 60 segundos. La planificación diaria con el Planner son 6 minutos. Las intervenciones más largas (el Shutdown Ritual, el protocolo pre-sueño) son de 15 minutos. Todo está diseñado para integrarse en lo que ya hacés, no para agregar una hora más al día.',
  },
  {
    question: '¿Está adaptado para Argentina?',
    answer:
      '100%. Hablamos de PedidosYa, Rappi y Uber Eats. De asados corporativos. De after offices. De mate. De la cultura laboral argentina de 9 a 17. De home office con familiares. No es material traducido del inglés: es un sistema creado desde Argentina para Argentina.',
  },
  {
    question: '¿Cómo recibo el material?',
    answer:
      'Inmediatamente después de la compra recibís un mail con el link de descarga de todos los PDFs. Acceso en menos de 5 minutos. No hay envío físico. Todo digital, todo descargable, todo tuyo para siempre.',
  },
  {
    question: '¿Tiene garantía real?',
    answer:
      'Sí. 7 días de garantía total. Si abrís los tomos y no es lo que esperabas, escribís a soporte y te devolvemos el 100% sin preguntas. Sin formularios complicados. Sin drama. La tasa de devolución es menor al 1% porque el sistema funciona.',
  },
  {
    question: '¿Qué lo diferencia de los libros de productividad que ya leí?',
    answer:
      'Los libros de productividad te dicen qué hacer. Este sistema te dice exactamente cómo hacerlo, a qué hora, con qué herramienta y en qué orden, dentro de una jornada laboral argentina real. No es teoría: son protocolos accionables con base científica, diseñados para alguien que no tiene tiempo de leer otro libro.',
  },
]

export const costRows = [
  {
    icon: 'battery',
    problem: 'Crash de energía a las 15:00 todos los días',
    cost: '2 horas de productividad perdidas por jornada · 400 horas por año',
  },
  {
    icon: 'coffee',
    problem: '5 cafés por día que no funcionan',
    cost: 'Taquicardia, ansiedad y peor sueño crónico',
  },
  {
    icon: 'heart',
    problem: 'Llegar a casa sin energía para la familia',
    cost: 'Los años que no vuelven',
  },
  {
    icon: 'moon',
    problem: 'Dormir mal 5 noches por semana',
    cost: 'Deterioro cognitivo acumulado medible',
  },
  {
    icon: 'posture',
    problem: 'Dolores de cuello y espalda "normales"',
    cost: 'Problema postural que empeora con cada año',
  },
  {
    icon: 'unplug',
    problem: 'Sin sistema de desconexión',
    cost: 'Rumiación nocturna que destruye el sueño',
  },
  {
    icon: 'loop',
    problem: 'El mismo ciclo el próximo lunes',
    cost: 'Y el que viene. Y el año que viene.',
  },
]
